<!-- Only shown to employees enabled for employee identification. -->
@if (loaded() && enabled()) {
  <section class="rounded-2xl border border-gray-200 bg-white p-4 shadow-sm sm:p-6">
    <header class="mb-4">
      <h3 class="text-base font-bold tracking-tight text-gray-800">Kassen-PIN</h3>
      <p class="mt-1 text-sm text-gray-500">
        Ihre persönliche 6-stellige PIN für kritische Aktionen am Kassengerät (z.&nbsp;B. manueller Geldtransit).
        Nur Sie kennen sie. Wählen Sie keine leicht zu erratende PIN (keine Wiederholungen oder Zahlenreihen).
        @if (hasPin()) {
          <span class="font-medium text-gray-600">Es ist eine PIN gesetzt.</span>
        } @else {
          <span class="font-medium text-gray-600">Es ist noch keine PIN gesetzt.</span>
        }
      </p>
    </header>

    <div class="grid grid-cols-1 gap-4 sm:grid-cols-2">
      @if (hasPin()) {
        <div class="sm:col-span-2">
          <label for="pin-current" class="mb-2 block text-sm font-bold tracking-tight text-gray-700">Aktuelle PIN</label>
          <input id="pin-current" name="pin-current" type="password" inputmode="numeric" autocomplete="off"
                 maxlength="6" placeholder="••••••" [value]="current()"
                 (input)="onCurrentInput($any($event.target).value)"
                 class="block w-full rounded-xl border border-gray-200 bg-white px-3 py-2.5 text-center tracking-[0.5em]
                        shadow-sm transition-all duration-200 focus:border-theme-primary-500 focus:ring-1
                        focus:ring-theme-primary-500 sm:text-sm"/>
        </div>
      }

      <div>
        <label for="pin-new" class="mb-2 block text-sm font-bold tracking-tight text-gray-700">Neue PIN</label>
        <input id="pin-new" name="pin-new" type="password" inputmode="numeric" autocomplete="off"
               maxlength="6" placeholder="••••••" [value]="pin()"
               (input)="onPinInput($any($event.target).value)" aria-describedby="pin-self-hint"
               class="block w-full rounded-xl border border-gray-200 bg-white px-3 py-2.5 text-center tracking-[0.5em]
                      shadow-sm transition-all duration-200 focus:border-theme-primary-500 focus:ring-1
                      focus:ring-theme-primary-500 sm:text-sm"/>
      </div>

      <div>
        <label for="pin-confirm" class="mb-2 block text-sm font-bold tracking-tight text-gray-700">PIN bestätigen</label>
        <input id="pin-confirm" name="pin-confirm" type="password" inputmode="numeric" autocomplete="off"
               maxlength="6" placeholder="••••••" [value]="confirm()"
               (input)="onConfirmInput($any($event.target).value)" aria-describedby="pin-self-hint"
               class="block w-full rounded-xl border border-gray-200 bg-white px-3 py-2.5 text-center tracking-[0.5em]
                      shadow-sm transition-all duration-200 focus:border-theme-primary-500 focus:ring-1
                      focus:ring-theme-primary-500 sm:text-sm"/>
      </div>
    </div>

    <p id="pin-self-hint" class="mt-2 min-h-5 text-sm text-red-600" aria-live="polite">
      @if (validationHint(); as hint) {
        {{ hint }}
      }
    </p>

    @if (successMessage(); as success) {
      <p class="mt-2 rounded-xl bg-green-50 px-3 py-2 text-sm font-medium text-green-700" role="status">{{ success }}</p>
    }
    @if (errorMessage(); as error) {
      <p class="mt-2 rounded-xl bg-red-50 px-3 py-2 text-sm font-medium text-red-700" role="alert">{{ error }}</p>
    }

    <div class="mt-4 flex justify-end">
      <button type="button" (click)="save()" [disabled]="!canSave()"
              class="rounded-2xl bg-theme-primary-600 px-4 py-2.5 text-sm font-medium text-white shadow-lg
                     transition-all duration-200 hover:bg-theme-primary-700 disabled:cursor-not-allowed
                     disabled:opacity-50">
        @if (saving()) { Speichern… } @else if (hasPin()) { PIN ändern } @else { PIN festlegen }
      </button>
    </div>
  </section>
}
